import React from 'react';
import classNames from 'classnames';
import { InfoDangerIcon, QuestionIcon, IIconProps } from 'components/icons';
import { RoundButton } from 'components/base/button/RoundButton';

import './tooltip.styles.scss';

export type TooltipPositionType =
	| 'bottom-left'
	| 'bottom-center'
	| 'bottom-right'
	| 'top-left'
	| 'top-center'
	| 'top-right';

interface ITooltip {
	text: string | JSX.Element;
	title?: string;
	wrapperClass?: string;
	Icon?: React.FC<IIconProps>;
	position?: TooltipPositionType;
	hideButton?: boolean;
	error?: boolean;
}

export const Tooltip: React.FC<ITooltip> = ({
	Icon = QuestionIcon,
	text,
	title,
	wrapperClass,
	position,
	hideButton,
	error,
}) => {
	const [isShown, handleShownTooltip] = React.useState(false);
	let timerId: NodeJS.Timeout;

	function handleMouseEnter() {
		clearTimeout(timerId);
		if (!isShown) {
			setTimeout(() => handleShownTooltip(true), 500);
		}
	}

	function handleMouseLeave() {
		timerId = setTimeout(() => handleShownTooltip(false), 500);
	}

	return (
		<div
			className={classNames('tooltip__wrapper', wrapperClass)}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			{!hideButton && error ? (
				<InfoDangerIcon pointer />
			) : (
				<>
					<RoundButton Icon={Icon} />
					{title && <span className="tooltip__title">{title}</span>}
				</>
			)}
			{isShown ? (
				<div
					className={classNames('tooltip__window', {
						'tooltip--position--bottom-left': position === 'bottom-left',
						'tooltip--position--bottom-center': position === 'bottom-center',
						'tooltip--position--bottom-right': position === 'bottom-right',
						'tooltip--position--top-left': position === 'top-left',
						'tooltip--position--top-center': position === 'top-center',
						'tooltip--position--top-right': position === 'top-right',
					})}
				>
					{text}
				</div>
			) : null}
		</div>
	);
};
